import { generatePath } from "react-router-dom";

import { ROUTE_PATHS } from "../../../utils/RoutesPaths";

export const COMPANY_DETAILS_OVERVIEW_TAB = "overview";
export const COMPANY_DETAILS_CLIENTS_TAB = "clients";

export const buildCompanyDetailsTabSearch = (tab) => `?tab=${tab}`;

export const adminCompanyClientRoutes = {
  companyDetails: (companyId) =>
    generatePath(ROUTE_PATHS.companiesListCompanyDetails, { id: companyId }),

  companyDetailsClientsTab: (companyId) =>
    `${generatePath(ROUTE_PATHS.companiesListCompanyDetails, {
      id: companyId,
    })}${buildCompanyDetailsTabSearch(COMPANY_DETAILS_CLIENTS_TAB)}`,

  companyDetailsTabLocation: (
    companyId,
    tab = COMPANY_DETAILS_OVERVIEW_TAB,
  ) => ({
    pathname: generatePath(ROUTE_PATHS.companiesListCompanyDetails, {
      id: companyId,
    }),
    search: buildCompanyDetailsTabSearch(tab),
  }),

  view: (companyId, clientId) =>
    generatePath(ROUTE_PATHS.adminCompanyViewClient, {
      companyId,
      id: clientId,
    }),

  create: (companyId) =>
    generatePath(ROUTE_PATHS.adminCompanyAddClient, { companyId }),

  edit: (companyId, clientId) =>
    generatePath(ROUTE_PATHS.adminCompanyEditClient, {
      companyId,
      id: clientId,
    }),
};
